import React, { useEffect, useRef } from 'react';
import { useRouter } from 'next/compat/router';
import { sanitizeUrl } from '@braintree/sanitize-url';

import useStores from 'shared/hooks/use-stores';
import { EnrollmentSteps } from 'src/payments/constants';
import { AuthContexts, useDutchiePayAnalytics } from 'src/payments/hooks';
import { useIsFirstRender } from 'src/hooks/use-is-first-render';

const getCurrentUrl = (): string => {
  const url = new URL(window.location.href);
  url.searchParams.delete('autoLogin');
  return sanitizeUrl(url.toString());
};

export function PayByBankOAuthLogin({ dispensaryId }: { dispensaryId?: string }): JSX.Element | null {
  const { Cart, User } = useStores();
  const { isLoggedIn } = User;
  const formRef = useRef<HTMLFormElement>(null);
  const { query } = useRouter() ?? {};
  const { token } = query ?? {};
  const currentUrl = getCurrentUrl();
  const isFirstRender = useIsFirstRender();

  const { trackEnrollmentStepViewed } = useDutchiePayAnalytics();

  useEffect(() => {
    if (isFirstRender) {
      trackEnrollmentStepViewed({ step: EnrollmentSteps.emailForm, context: AuthContexts.AUTH_OAUTH });
    }
  }, [isFirstRender, trackEnrollmentStepViewed]);

  // Initiate the Oath flow
  useEffect(() => {
    if (!!dispensaryId && !token && formRef.current) {
      formRef.current.submit();
    }
  }, [dispensaryId, token]);

  // Login the user with the token returned from the Oath flow
  useEffect(() => {
    if (token && !User.token) {
      User.updateToken(token);
    }
  }, [token, User]);

  if (isLoggedIn) {
    return null;
  }

  return (
    <form ref={formRef} method='post' action='/api/v2/auth/omniauth_generic'>
      <input type='hidden' name='checkout_url' value={currentUrl} />
      <input type='hidden' name='dispensary_id' value={dispensaryId} />
      <input type='hidden' name='promo' value={Cart.coupon?.code ?? null} />
    </form>
  );
}
